import { injectable } from 'inversify'
import { TransientService as TransientService } from './TransientService'

@injectable()
export class DefaultTransientService implements TransientService {
  random: number
  constructor() {
    this.random = Math.floor(Math.random() * 10000)
  }

  getData(): string {
    return 'TransientService - ' + this.random
  }
}

//  DON'T DELETE - used by DW
